import { render, staticRenderFns } from "./LegoSelectCollaborator.vue?vue&type=template&id=2f9fe1ac&scoped=true"
import script from "./LegoSelectCollaborator.vue?vue&type=script&lang=js"
export * from "./LegoSelectCollaborator.vue?vue&type=script&lang=js"
import style0 from "./LegoSelectCollaborator.vue?vue&type=style&index=0&id=2f9fe1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9fe1ac",
  null
  
)

export default component.exports